module.exports = __webpack_public_path__ + "img/allrubrics.08291d8.png";